import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './block-link.scss';

export class BlockLink extends PureComponent {
  render() {
    const { title, link, label } = this.props.content;

    return (
      <div className="block-link">
        {(!!title) &&
          <h5 dangerouslySetInnerHTML={{ __html: title }} />
        }

        <Link
          to={link}
          className="btn btn-flex solid-turq"
        >
          <span>
            <em>Подробнее<span className="icon">→</span></em>
            <span dangerouslySetInnerHTML={{ __html: label }} />
          </span>
        </Link>
      </div>
    );
  }
}

BlockLink.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    label: PropTypes.string
  })
};

export default BlockLink;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/BlockLink.js